import React from 'react';
import styles from './styles.module.scss';

const Arrow = () => (
  <div className={styles.arrow} />
);

export default Arrow;
